import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35c3f93c"
import script from "./templateModule.js?vue&type=script&lang=js&external"
export * from "./templateModule.js?vue&type=script&lang=js&external"
import style0 from "./templateModule.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports